export default function shouldShowHostingSetup(product, addonNames) {
  const names = typeof addonNames === 'string' ? addonNames : '';

  return !!product
    && product.module_name === 'cpanel'
    && names.indexOf('Migration') === -1;
}
